import { useQuery } from 'data-fetching-client';
import { USERS_AND_TEAMS_HIERARCHY_QUERY } from '../queries/fetchUsersAndTeamsHierarchy';
export const useFetchUsersAndTeamsHierarchy = options => useQuery(USERS_AND_TEAMS_HIERARCHY_QUERY, {
  variables: {
    inboxId: (options || {}).inboxId
  },
  skip: (options || {}).skip
});